var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39359 1.5719L7.29105 6.23051M7.29105 6.23051L12.3713 8.2353M7.29105 6.23051C8.67359 5.37617 10.2728 4.74073 12.0151 4.57133C18.0283 3.98666 23.37 8.3027 23.9444 14.2101C24.5188 20.1175 20.1086 25.3818 14.0954 25.9664C8.08213 26.5511 2.74047 22.2351 2.16609 16.3276C1.99967 14.616 2.25386 12.9595 2.84112 11.4626",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.970e0074e5a92f0fb11dee5f9fb44ddc.svg";
export { ForwardRef as ReactComponent };